import {app, ServiceMethodsLangFilesAccepted} from "@app/api/initialFethersjs";
import {MLanguageFilesAccepted} from "@elte/translate-backend/interface/lang_files_accepted";
// import {MLanguageFilesAccepted} from "@elte/translate-backend/interface/lang_files_accepted";
export import TResponseFind = MLanguageFilesAccepted.TResponseFind;
export import TRequestDateCreate = MLanguageFilesAccepted.TRequestDateCreate;
import TResponseGet = MLanguageFilesAccepted.TResponseGet;

// import {TRequestDateCreate} from "@elte/translate-backend/interface/";


export class LangFilesAcceptedApi implements MLanguageFilesAccepted.IService {
    endPoint: ServiceMethodsLangFilesAccepted;


    constructor() {
        this.endPoint = app.service("lang_files_accepted")
    }


    find(): Promise<MLanguageFilesAccepted.TResponseFind[]> {
        return this.endPoint.find().then(value => {
            if (Array.isArray(value)) {
                return value
            }
            return []
        }, reason => null);
    }


    get(id: string, params: MLanguageFilesAccepted.TRequestGetParams): Promise<MLanguageFilesAccepted.TResponseGet> {

        return this.endPoint
            .get(id, {query: {lang: params.query.lang}})
            .then((value) => {
                const t: TResponseGet = value as any;
                return t;
            })
    }

    create(data: MLanguageFilesAccepted.TRequestDateCreate): Promise<MLanguageFilesAccepted.TRequestDateCreate> {
        return this.endPoint.create(data).then((value) => {
            let newValue: TRequestDateCreate = value as any;
            return {
                lang: newValue.lang,
                accept: newValue.accept,
                fileId: newValue.fileId,
                remove: newValue.remove
            }
        });
    }

    remove(id: string, params: MLanguageFilesAccepted.TRequestRemoveParams): Promise<MLanguageFilesAccepted.Data> {
        return this.endPoint.remove(id, {query: {lang: params.query.lang}}).then(value => {
            return value
        })
    }

}

